import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520af11c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sorry, an unexpected error occurred.", -1))
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}

import { onMounted, ref } from 'vue'
import { AlertTriangleIcon } from '@zhuowenli/vue-feather-icons'
import Modal from './Modal.vue'
import { unexpectedErrorEvent } from './AppUtil'
import { useTelemetry } from './Telemetry'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  setup(__props) {

const modalRef = ref<InstanceType<typeof Modal>>()
const messageRef = ref<string>()

const { trackException } = useTelemetry()

onMounted(() => {
  unexpectedErrorEvent.on(args => {
    if (args.error) {
      trackException(args.error)
    }
    messageRef.value = args.error instanceof Error ? args.error.message : undefined
    modalRef.value?.open()
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    info: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Something went wrong")
    ]),
    icon: _withCtx(() => [
      _createVNode(_unref(AlertTriangleIcon), { class: "icon" })
    ]),
    okText: _withCtx(() => [
      _createTextVNode("OK")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (messageRef.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(messageRef.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})